import React, { Component, Fragment } from 'react'
import { NavLink } from 'react-router-dom';

export default class OtherSideComponents extends Component {
    render() {
        return (
            <Fragment>
                <li><NavLink to='/land'><i className='fa fa-map-o' /><span> Plots </span></NavLink> </li>
                <li><NavLink to='/agents'><i className='fa fa-user' /><span> Agents </span></NavLink></li>
                <li><NavLink to='/clients'><i className='fa glyphicon-user' /><span> Client </span></NavLink></li>
                <li><NavLink to='/community'><i className='fa fa-users' /><span> Community </span></NavLink></li>
                <li><NavLink to='/payments'><i className='fa fa-money' /><span> Payments </span></NavLink></li>
                <li><NavLink to='/paymentMethods'><i className='fa fa-bank' /><span> Methods </span></NavLink></li>
                <li><NavLink to='/relationships'><i className='fa fa-recycle' /><span> Relationships </span></NavLink></li>
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Components/Navigation/OtherSideComponents.js